import React from "react";
import "./Popup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function Popup({
    isOpen,
    title,
    children,
    onClose,
    onCancel,
    onConfirm,
    cancelText = "Cancelar",
    confirmText = "Confirmar",
    confirmDisabled = false,
    cancelDisabled = false,
    showCancel = true,
    closeOnOverlay = true,
    maxWidth = "500px",
    height,
}) {
    if (!isOpen) {
        return null;
    }

    const handleOverlayClick = (event) => {
        if (!closeOnOverlay) {
            return;
        }

        if (event.target === event.currentTarget) {
            onClose?.();
        }
    };

    return (
        <div className="popup-overlay" onClick={handleOverlayClick}>
            <div className="popup-content" style={{ maxWidth, height, maxHeight: height, overflowY: height ? "auto" : undefined }}>
                <button
                    type="button"
                    className="popup-close"
                    onClick={onClose}
                    aria-label="Cerrar popup"
                >
                    <FontAwesomeIcon icon={faXmark} size="xl" />
                </button>

                <div className="popup-header">
                    <h2 className="popup-title">{title}</h2>
                    <div className="divider" aria-hidden="true"></div>
                </div>

                <div className="popup-body">
                    {children}
                </div>

                <div className="popup-actions">
                    {showCancel && (
                        <button
                            type="button"
                            className="secundary"
                            onClick={onCancel || onClose}
                            disabled={cancelDisabled}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
